var Loyers_Details = {

	currentSlide:0,
	timeout_openFirst:0,
	isOpenFirst:false,

	init:function(){

		/*
		$(window).resize(function(){
			Loyers_Details.resize();
		});
		Loyers_Details.resize();
		*/

		Loyers_Details.create_carousel_desktop();
		Loyers_Details.create_carousel_mobile();

		if($(".loyers-details .desktop").css("display") == "block"){

			Loyers_Details.isOpenFirst = false;
		}else{

			clearTimeout(Loyers_Details.timeout_openFirst);
			if(Loyers_Details.isOpenFirst == false){

				Loyers_Details.isOpenFirst = true;

				Loyers_Details.timeout_openFirst = setTimeout(function(){
					Accordeon.clickOn($(".loyers-details .mobile").find(".item:first-child"));
				}, 600);

			}

		}



		$(".loyers-details .slider-menu").find(".button-container").mouseenter(function(){
			if(!$(this).hasClass("slick-current")){
				Loyers_Details.roll_entoure($(this).index(), 'over');
			}
		}).mouseleave(function(){
			if(!$(this).hasClass("slick-current")){
				Loyers_Details.roll_entoure($(this).index(), 'out');
			}
		});

	},
	removeCarousel:function(){
		var _carousel_menu = $(".loyers-details .slider-menu");
		var _carousel_content = $(".loyers-details .slider-contents");

		var _carousel_mobile = $(".loyers-details .slider-mobile");

		if (_carousel_menu.hasClass('slick-initialized')) {
			_carousel_menu.slick('unslick');
		}
		if (_carousel_content.hasClass('slick-initialized')) {
			_carousel_content.slick('unslick');
		}
		if (_carousel_mobile.hasClass('slick-initialized')) {
			_carousel_mobile.slick('unslick');
		}
	},
	create_carousel_desktop:function(){
		var _carousel_menu = $(".loyers-details .slider-menu");
		var _carousel_content = $(".loyers-details .slider-contents");

		_carousel_menu.slick({
			arrows:false, 
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: 4,
			focusOnSelect: true,
			touchThreshold:500,
			asNavFor:_carousel_content
		});	
		_carousel_content.slick({
			arrows:false, 
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: 1,
			focusOnSelect: true,
			centerMode: true,
			touchThreshold:500,
			asNavFor:_carousel_menu
		});

		_carousel_content.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			Loyers_Details.currentSlide = nextSlide;

			setTimeout(function(){
				if($(".loyers-details .desktop").css("display") == "block"){
					console.log("1");
					Loyers_Details.change_entoure();
				}
			}, 100);
		});

		setTimeout(function(){
			if($(".loyers-details .desktop").css("display") == "block"){

				
				Loyers_Details.change_entoure();
			}
		}, 100);

	},
	change_entoure:function(){

		if($(".loyers-details .desktop").css("display") != "none"){

			var els = document.querySelectorAll("[svgator-selected]");

			Array.prototype.forEach.call(els, function(el, i) {

				if(el.parentNode.classList.contains('slick-current')){

					if(el.classList.contains('played') == false){
						/*el.classList.add("played");*/
						Loyers_Details.dispatch_click(el);
					}
				}else{
					if(el.classList.contains('played') == true){
						/*el.classList.remove("played");*/
						Loyers_Details.dispatch_click(el);
					}
				}

			});
		}
	},
	roll_entoure:function(pID, pType){

		
		if($(".loyers-details .desktop").css("display") != "none"){

			var els = document.querySelectorAll("[svgator-selected]");

			Array.prototype.forEach.call(els, function(el, i) {
				if(pID == i){

					// ROLLOVER
					if((pType == 'over') && (el.classList.contains('played') == false)){
						Loyers_Details.dispatch_click(el);
					}
					// ROLLOUT
					if((pType == 'out') && (el.classList.contains('played') == true)){
						Loyers_Details.dispatch_click(el);
					}
				}else{
					/*
					
					if((pType == 'over') && (el.classList.contains('played') == true)){
						Debug.log("REMOVE ENTOURE : " + i);
						Loyers_Details.dispatch_click(el);
					}

					if(pType == 'out'){
						if(el.parentElement.classList.contains('slick-current') == true){
							
							if(el.classList.contains('played') == false){
								Debug.log("ADD ENTOURE SELECTED : " + i);
								Loyers_Details.dispatch_click(el);	
							}
						}
					}
					*/
				}

			});
		}

	},
	dispatch_click:function(pTarget){

		var _svgs = pTarget.getElementsByTagName("svg");
		var _isObject = pTarget.getElementsByTagName("object")[0];

		if(typeof _isObject == "undefined"){	
			
			Array.prototype.forEach.call(_svgs, function(_svg) {
				
				pTarget.classList.toggle("played");
				_svg.dispatchEvent(new Event("click"));
			});
		}else{
			if(pTarget.getElementsByTagName("object")[0].getSVGDocument() != null){

				var _svgs_2 = pTarget.getElementsByTagName("object")[0].getSVGDocument().getElementsByTagName("svg")[0];

				if(typeof _svgs_2 != "undefined"){

					pTarget.classList.toggle("played");
					_svgs_2.dispatchEvent(new Event("click"));
				}else{
					Debug.log("SVG_2 IS UNDEFINED");
					
					setTimeout(function(){
						Loyers_Details.dispatch_click(pTarget);
					}, 100);
				}
			}else{
				Debug.log("SVG NON TROUVE");
			}
		}
	},
	create_carousel_mobile:function(){
		var _carousel_mobile = $(".loyers-details .slider-mobile");


		var _slides_to_show = 1;
		var els = document.querySelectorAll(".slider-mobile");

		Array.prototype.forEach.call(els, function(el) {
			//Debug.log("SLIDES TO SHOW : " + el + " => " + parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide")));

			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));

		});


		var _center_mode = false;

		if(_slides_to_show == 1){
			_center_mode = true;
		}

		_carousel_mobile.slick({
			arrows:false, 
			dots:true,
			infinite: false,
			variableWidth:true,
			centerMode:_center_mode,
			slidesToShow: _slides_to_show,
			focusOnSelect: true,
			touchThreshold:500
		});	
	},
	resize:function(){
		Loyers_Details.create_carousel_desktop();
		/*Loyers_Details.removeCarousel();

		if($(".loyers-details .desktop").css("display") == "block"){

			var els = document.querySelectorAll("[svgator-selected]");

			Array.prototype.forEach.call(els, function(el, i) {
				if(el.classList.contains('played') == true){
					Debug.log("RESIZE : REMOVE CURRENT PLAYED : " + i);

					Loyers_Details.dispatch_click(el);
				}

			}	);



			Loyers_Details.create_carousel_desktop();
			Loyers_Details.isOpenFirst = false;
		}else{
			Loyers_Details.create_carousel_mobile();

			clearTimeout(Loyers_Details.timeout_openFirst);
			if(Loyers_Details.isOpenFirst == false){

				Loyers_Details.isOpenFirst = true;

				Loyers_Details.timeout_openFirst = setTimeout(function(){
					Accordeon.clickOn($(".loyers-details .mobile").find(".item:first-child"));
				}, 600);

			}

		}
		*/
	}
}

$(window).load(function(){
	if($(".loyers-details").length){
		Loyers_Details.init();
	}
})